import * as ko from 'knockout';
import dashboard from './dashboard';

export default function () {
  ko.components.register(dashboard.name, dashboard);
}
